'use client';

import { c as _c } from "react/compiler-runtime";
import { signIn } from 'next-auth/react';
import { AccountButton } from './AccountButton';

/**
 * Client-only wrapper around AccountButton that triggers the signIn flow.
 */
export function SignInAccountButton(t0) {
  const $ = _c(5);
  const {
    label,
    concept
  } = t0;
  let t1;
  if ($[0] !== concept) {
    t1 = () => signIn("duende", undefined, {
      concept
    });
    $[0] = concept;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label || $[3] !== t1) {
    t2 = <AccountButton data-testid="header-button-sign-in" onPress={t1} aria-label={label} />;
    $[2] = label;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}